import { alertConstants } from "../constants";

export const alertActions = {
    success,
    error,
    clear
}

function success(message) {
    return { type: alertConstants.SUCCESS, message };
}

function error(message, fields = {}) {
    return { type: alertConstants.ERROR, message, fields };
}

function clear() {
    return { type: alertConstants.CLEAR };
}